import {
  DELEGATION_GET_BUYERS_LIST_URL,
  DELEGATION_GET_SELLERS_LIST_URL,
  DELEGATION_VALIDATE_SELLER_CODE_URL,
} from '@1po/1po-bff-fe-spec/generated/delegation/DelegationURLs';
import { GetDelegationSeller } from '@1po/1po-bff-fe-spec/generated/delegation/request/GetDelegationSeller';
import { GetPossibleBuyersForSeller } from '@1po/1po-bff-fe-spec/generated/delegation/request/GetPossibleBuyersForSeller';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';

import { WebSocketAction } from 'utils/domainStore';
import { wsSendCommandAction, wsSendQueryAction } from 'utils/domainStore/api';
import {
  CONNECT_DELEGATION_SESSION_RESPONSE,
  ConnectDelegationRequest,
  DELEGATION_SESSION_ERROR,
  DISCONNECT_DELEGATION_SESSION_RESPONSE,
  EXTEND_DELEGATION_SESSION_RESPONSE,
  GET_DELEGATION_SELLER_RESPONSE,
  GET_ACTIVE_DELEGATION_SESSION_RESPONSE,
  GET_POSSIBLE_BUYERS_TO_DELEGATE_RESPONSE,
  GET_POSSIBLE_SELLERS_TO_DELEGATE_RESPONSE,
} from './DelegationSession.types';

export const DELEGATION_WS_BASE = '/delegation';

export const CONNECT_DELEGATION_URL = `${DELEGATION_WS_BASE}/connect`;
export const DISCONNECT_DELEGATION_URL = `${DELEGATION_WS_BASE}/disconnect`;
export const EXTEND_DELEGATION_URL = `${DELEGATION_WS_BASE}/extend`;
export const GET_ACTIVE_DELEGATION_URL = `${DELEGATION_WS_BASE}/active`;

RequestResponseMappingManager.addMapping(CONNECT_DELEGATION_URL, CONNECT_DELEGATION_SESSION_RESPONSE);
RequestResponseMappingManager.addMapping(DISCONNECT_DELEGATION_URL, DISCONNECT_DELEGATION_SESSION_RESPONSE);
RequestResponseMappingManager.addMapping(EXTEND_DELEGATION_URL, EXTEND_DELEGATION_SESSION_RESPONSE);
RequestResponseMappingManager.addMapping(GET_ACTIVE_DELEGATION_URL, GET_ACTIVE_DELEGATION_SESSION_RESPONSE);
RequestResponseMappingManager.addMapping(DELEGATION_GET_SELLERS_LIST_URL, GET_POSSIBLE_SELLERS_TO_DELEGATE_RESPONSE);
RequestResponseMappingManager.addMapping(DELEGATION_VALIDATE_SELLER_CODE_URL, GET_DELEGATION_SELLER_RESPONSE);
RequestResponseMappingManager.addMapping(DELEGATION_GET_BUYERS_LIST_URL, GET_POSSIBLE_BUYERS_TO_DELEGATE_RESPONSE);
RequestResponseMappingManager.addMapping('error', DELEGATION_SESSION_ERROR);

export function sendConnectDelegation(request: ConnectDelegationRequest): WebSocketAction {
  return wsSendCommandAction(CONNECT_DELEGATION_URL, request);
}

export function sendDisconnectDelegation(): WebSocketAction {
  return wsSendCommandAction(DISCONNECT_DELEGATION_URL, null);
}

export function sendExtendDelegation(minutes = 30): WebSocketAction {
  return wsSendCommandAction(EXTEND_DELEGATION_URL, { minutes });
}

export function sendGetActiveDelegation(): WebSocketAction {
  return wsSendQueryAction(GET_ACTIVE_DELEGATION_URL, null);
}

export function sendGetPossibleSellersForDelegation(): WebSocketAction {
  return wsSendQueryAction(DELEGATION_GET_SELLERS_LIST_URL, null);
}

export function sendGetDelegationSeller(request: GetDelegationSeller): WebSocketAction {
  return wsSendQueryAction(DELEGATION_VALIDATE_SELLER_CODE_URL, request);
}

export function sendGetPossibleBuyersForDelegation(request: GetPossibleBuyersForSeller): WebSocketAction {
  return wsSendQueryAction(DELEGATION_GET_BUYERS_LIST_URL, request);
}
